import "./Feedback.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../Images/button.png";
import symbol from "../Images/symbol.png";
import f1 from "../Images/f1.jpg";
import f2 from "../Images/f2.jpg";
import f3 from "../Images/f3.jpg";
const Feedback = () => {
  const data = [
    {
      id: 1,
      image: f1,
      name: "Anita R.",
      position: "— EdTech Program Director",
      feedback:
        "The AR learning tools developed by the team completely transformed our classroom experience. Students are more engaged, and complex topics have become easier to understand. Truly a game-changer in modern education!",
    },
    {
      id: 2,
      image: f2,
      name: "Priya S.",
      position: "— Marketing Manager, LuxeWear",
      feedback:
        "We saw an instant boost in customer engagement after launching our AR try-on feature. Their team nailed the user experience and helped us stand out in a competitive market.",
    },
    {
      id: 3,
      image: f3,
      name: "Ravi Malhotra",
      position: "— Operations Lead, TechForge Industries",
      feedback:
        "The AR-guided workflows helped us cut training time in half. New hires get up to speed faster, and our    operations have never run smoother. Incredible ROI.",
    },
    {
      id: 4,
      image: f2,
      name: "Priya S.",
      position: "— Marketing Manager, LuxeWear",
      feedback:
        "We saw an instant boost in customer engagement after launching our AR try-on feature. Their team nailed the user experience and helped us stand out in a competitive market.",
    },
  ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id="feedback" className="divWrapper">
      <div className="arvrcontainer feedbackContainer">
      
         <h2 className="heading">
          Feedback That Drives Us <br />Forward/Your Satisfaction, Our Success-
        </h2>
        <Slider {...settings}>
          {data.map((item) => {
            return (
              <div className="fwrapper" key={item.id}>
                <div className="fbox">
                  <div className="symbolbox">
                    <img src={symbol} alt="" className="symbolimage" />
                  </div>
                  <div className="fcontent">
                    <p>{item.feedback}</p>
                    <div className="personinfo">
                      <h3>{item.name}</h3>
                      <h4>{item.position}</h4>
                    </div>
                  </div>
                  <div className="profilebox">
                    <img src={item.image} alt="" className="profileimage" />
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Feedback;
